import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ModelSwitchPayload = {
  name: string;
  value: string;
  premium?: boolean;
};

@Injectable({ providedIn: 'root' })
export class ModelSwitchOverlayService {
  private _state = new BehaviorSubject<ModelSwitchPayload | null>(null);
  state$ = this._state.asObservable();

  show(payload: ModelSwitchPayload, durationMs = 1300) {
    this._state.next(payload);
    window.setTimeout(() => this._state.next(null), durationMs);
  }

  clear() {
    this._state.next(null);
  }
}
